export function fn() {
	return "fn";
}
export var one = "one", two = "two";

export var test1 = fn();
export var test2 = two;
